import { Tile, TileHeader } from '@creditflowresearch/uilib/Tile';
import Title from '@creditflowresearch/uilib/Title';
import { Product } from '@/creditflowresearch/domain/Product';
import { AbsProduct } from '@/creditflowresearch/domain/Product';
import { useDealPageContext } from '@/creditflowresearch/application/Deal/contexts/DealPageContext';
import { CorporateDealsPageTable } from '@/creditflowresearch/ui/components/deals/DealListTable/DealsTable/CorporateDealsPageTable';
import { DealPageTable } from '@/creditflowresearch/ui/components/deals/DealListTable/DealsTable/DealPageTable';
import { withDealPageContext } from '@/creditflowresearch/ui/components/deals/DealTiles/withDealPageContext';

const DealPageTile = () => {
  const { deal } = useDealPageContext();
  const isCorporate = !Product.isOfType(deal.product.id, AbsProduct.TYPE);

  return (
    <Tile dataTest="dealTile">
      <TileHeader title={ <Title title="Deal Details" dataTest="dealTileTitle" /> } dataTest="dealTileHeader" />
      { isCorporate ? (
        <CorporateDealsPageTable />
      ) : (
        <DealPageTable showDealDetailsByDefault defaultExpandedRowIndexes={ [0] } />
      ) }
    </Tile>
  );
};

export default withDealPageContext(DealPageTile);
